import { SupportedChainId } from "./chains";

interface AMMInfo {
    logoUrl: string,
    label: string
}

export const AMMS_INFO: { [key: string]: AMMInfo } = {
// export const AMMS_INFO = {
    'UniswapV2': {
        logoUrl: './images/UniswapV2.png',
        label: 'UniswapV2'
    },
    'UniswapV3': {
        logoUrl: './images/UniswapV3.png',
        label: 'UniswapV3'
    },
    'SushiSwap': {
        logoUrl: './images/SushiSwap.png',
        label: 'SushiSwap'
    },
    'PancakeSwap': {
        logoUrl: './images/PancakeSwap.png',
        label: 'PancakeSwap'
    },
    'Trisolaris': {
        logoUrl: './images/Trisolaris.png',
        label: 'Trisolaris'
    },
    'Ubeswap': {
        logoUrl: './images/Ubeswap.png',
        label: 'Ubeswap'
    },
}

export const AMMS_PER_NETWORK = {
    // [SupportedChainId.MAINNET]: ['UniswapV2', 'SushiSwap'],
    // [SupportedChainId.GOERLI]: ['UniswapV2', 'UniswapV3', 'SushiSwap'],
    // [SupportedChainId.KOVAN]: ['UniswapV2', 'SushiSwap'],
    [SupportedChainId.ALFAJORES]: ['Ubeswap', 'UniswapV3'],
    [SupportedChainId.CELO]: [],
    [SupportedChainId.AURORA]: ['Trisolaris'],
    // [SupportedChainId.AURORA_TEST]: ['Trisolaris'],
    // [SupportedChainId.OPTIMISM]: [],
    // [SupportedChainId.OPTIMISTIC_KOVAN]: [],
    // [SupportedChainId.ARBITRUM_ONE]: [],
    // [SupportedChainId.ARBITRUM_RINKEBY]: [],
    // [SupportedChainId.POLYGON]: ['Trisolaris'],
    // [SupportedChainId.POLYGON_MUMBAI]: ['PancakeSwap'],
}


